import emailjs from '@emailjs/browser';
import React, { useRef } from 'react';
import { toast } from 'react-toastify';

function ContactUs() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_5ee2ibu', 'template_ni7wc0o', form.current, 'BQPU_wqp3_JVD0Pc2')
      .then(() => {
        toast.success(" Message sent successfully!", {
          position: "top-right",
          autoClose: 3000,
          theme: "dark"
        });
      }, () => {
        toast.error(" Failed to send message!", {
          position: "top-right",
          autoClose: 3000,
          theme: "dark"
        });
      });

    form.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    e.target.reset();
  };

  return (
    <div  className="min-h-screen flex items-center justify-center bg-gradient-to-r from-sky-900 to-gray-900 p-6">
      <div className="w-full max-w-3xl bg-white bg-opacity-10 backdrop-blur-md border border-white border-opacity-20 shadow-2xl rounded-2xl p-10 text-white">
        <h1 className="text-4xl font-extrabold text-center mb-8 tracking-wide">Get in Touch</h1>

        <form ref={form} onSubmit={sendEmail} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label htmlFor="name" className="block mb-2 font-semibold">Name</label>
              <input
                required
                id="name"
                name="name"
                type="text"
                placeholder="Enter your name"
                className="w-full px-4 py-3 rounded-lg bg-white bg-opacity-20 placeholder-white placeholder-opacity-60 text-white focus:outline-none focus:ring-2 focus:ring-cyan-400"
              />
            </div>
            <div>
              <label htmlFor="email" className="block mb-2 font-semibold">Email</label>
              <input
                required
                id="email"
                name="email"
                type="email"
                placeholder="Enter your email"
                className="w-full px-4 py-3 rounded-lg bg-white bg-opacity-20 placeholder-white placeholder-opacity-60 text-white focus:outline-none focus:ring-2 focus:ring-cyan-400"
              />
            </div>
          </div>

          <div>
            <label htmlFor="message" className="block mb-2 font-semibold">Message</label>
            <textarea
              required
              id="message"
              name="message"
              rows="5"
              placeholder="Type your message here..."
              className="w-full px-4 py-3 rounded-lg bg-white bg-opacity-20 placeholder-white placeholder-opacity-60 text-white focus:outline-none focus:ring-2 focus:ring-cyan-400"
            />
          </div>

          <div className="text-center">
            <button
              type="submit"
              className="bg-cyan-500 hover:bg-cyan-600 text-white font-semibold px-8 py-3 rounded-lg shadow-md transform hover:scale-105 transition-transform"
            >
              Send Message
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ContactUs;
